
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Main_Data_Number","data-name":"Main Data Number","transform":"translate(-767 -213)"}},[_c('g',{attrs:{"id":"Main_Data_type_date","data-name":"Main Data type date","transform":"translate(665.849 -326.148)"}},[_c('rect',{attrs:{"id":"Rectangle_9038","data-name":"Rectangle 9038","width":"14","height":"14","transform":"translate(101.151 539.148)","fill":"none"}})]),_c('g',{attrs:{"id":"Group_30459","data-name":"Group 30459","transform":"translate(767.131 216.19)"}},[_c('g',{attrs:{"id":"Group_30460","data-name":"Group 30460","transform":"translate(1.169 .809)"}},[_c('g',{attrs:{"id":"Group_30461","data-name":"Group 30461","fill":"none","stroke":"#96a0ae","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2"}},[_c('path',{attrs:{"id":"Path_21031","data-name":"Path 21031","d":"M10.557 6.386h2.978V.6h-2.978m2.978 2.894h-1.986","transform":"translate(-1.957 -.599)"}}),_c('path',{attrs:{"id":"Path_21032","data-name":"Path 21032","d":"M1.831 6.478V.6H.6","transform":"translate(-1.1 -.6)"}}),_c('path',{attrs:{"id":"Path_21033","data-name":"Path 21033","d":"M7.506 6.387H4.531v-2.03L7.506 2.7V.6H4.531","transform":"translate(-1.032 -.599)"}})])])])])])
          )
        }
      }
    